export default {
  power: 'Surat Kuasa',
  validation: 'Pengesahan Fotokopi Dokumen'
};
